type PhotoPlaceholderProps = {
  label?: string;
  sublabel?: string;
  className?: string;
};

export default function PhotoPlaceholder({
  label = "照片待補",
  sublabel,
  className = "",
}: PhotoPlaceholderProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center bg-primary/5 border border-line rounded-card ${className}`}
    >
      <div className="w-12 h-12 flex items-center justify-center">
        <i className="ri-image-line text-3xl text-ink-soft/60" aria-hidden="true"></i>
      </div>
      <p className="mt-3 text-sm font-semibold text-ink-soft">{label}</p>
      {sublabel && <p className="mt-1 text-xs text-ink-soft/70">{sublabel}</p>}
    </div>
  );
}